import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";  // Import Link here
import "./HomePage.css";
import newsData from "./newsData";
import scheduleData from "./scheduleData";

const recentNews = [...newsData]
  .sort((a, b) => b.id - a.id) // Sort by ID descending (most recent first)
  .slice(0, 5); // Take the top 5


const today = new Date();
const currentWeek = scheduleData.find(
  (week) => new Date(week.date) >= today
) || scheduleData[scheduleData.length - 1]; // fallback to last week

const nextWeekIndex = scheduleData.findIndex(
  (week) => week.week === currentWeek.week
);
const previousWeek = scheduleData[nextWeekIndex - 1];


const navItems = [
  { label: "Home", path: "/" },
  { label: "Managers", path: "/managers" },
  { label: "Seasons", path: "/seasons" },
  { label: "League Settings", path: "/league-settings" },
];

const HomePage = () => {
  return (
    <div className="homepage-container">
      {/* Header */}
      <header className="header">
        <nav className="nav-bar">
          {navItems.map(({ label, path }, i) => (
            <Link key={i} to={path} className="nav-link" tabIndex={0}>
              {label}
            </Link>
          ))}
        </nav>
      </header>

      {/* Fade-in "Footballin" title, simple opacity fade */}
      <motion.h1
        className="footballin-title"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.1, duration: 0.6 }}
      >
        Footballin
      </motion.h1>

      {/* Main Content */}
      <main className="main-content">
        <motion.section
        className="card"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1, duration: 0.6 }}
        >
        <h2 className="section-title">🏆 Reigning Champion</h2>
        <p className="section-text">
            <strong>Dave Criss </strong>(Dave's Duds) <br></br>
            A first year rookie, Dave took home the championship in 2024 with a record of 10-4. He defeated <strong>Chris Bode</strong> in the championship,
            to finish with a 10 win streak including the playoffs, becoming the first rookie to win the championship in footballin history.
        </p>
        <hr className="divider" /><hr></hr><br></br>

        <h3 className="section-subtitle">Previous Champions</h3>
        <ul className="champion-list">
            <li>2023 – Maxwell Snow</li>
            
            {/* ⬇️ Add more champions below this line */}
            {/* <li>2022 – John Smith</li> */}
            {/* <li>2021 – Sarah Blaze</li> */}
        </ul>
        </motion.section>


        <motion.section
        className="card"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.3, duration: 0.6 }}
        >
        <h2 className="section-title">📅 Schedule</h2>
        <ul className="schedule-list">
            <li>Feature Currently Under Development</li>
        </ul>

        <div className="week-info">
            <h3 className="section-subtitle">Upcoming Week {currentWeek.week}</h3>
            <ul className="matchup-list">
            {currentWeek.matchups.map((matchup, index) => (
                <li key={index}>
                {matchup.team1} vs. {matchup.team2}
                </li>
            ))}
            </ul>

            {previousWeek && (
            <>
                <h4 className="section-subtitle">Previous Week {previousWeek.week}</h4>
                <ul className="matchup-list">
                {previousWeek.matchups.map((matchup, index) => (
                    <li key={index}>
                    {matchup.team1} vs. {matchup.team2}
                    </li>
                ))}
                </ul>
            </>
            )}
        </div>
        </motion.section>


        <motion.section
        className="card"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5, duration: 0.6 }}
        >
        <h2 className="section-title">📰 News</h2>
        <ul className="news-list">
        {recentNews.map((item) => (
            <li key={item.id} className="news-item">
            <span className="news-date">{item.date}</span>
            <span className="news-text">{item.text}</span>
            </li>
        ))}
        </ul>
        </motion.section>
      </main>

      {/* Footer */}
      <footer className="footer">Created by Nick Criss ⚡️</footer>
    </div>
  );
};

export default HomePage;
